<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-combobox
        item-value="key"
        item-text="value"
        :items="items"
        :value="value"
        :error-messages="errors"
        :label="label"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        eager
        :dense="dense"
        @change="change"
        @contextmenu.prevent>
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default: () => { return [] }
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      }
    },
    watch: {
      items: {
        deep: true,
        immediate: true,
        handler (newItems) {
          if (newItems.length === 1 && !this.value) {
            this.change(newItems[0])
          }
        }
      }
    },
    methods: {
      change: function (item) {
        this.$emit('input', item || null)
        this.$emit('change')
      }
    }
  }
</script>
